(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var toggle = document.querySelector('[data-drawer-toggle]');
    var drawer = document.querySelector('[data-drawer]');
    var overlay = document.querySelector('[data-drawer-overlay]');
    var close = document.querySelector('[data-drawer-close]');
    var header = document.querySelector('.header');

    if (!toggle || !drawer || !overlay) return;

    function openDrawer() {
      drawer.classList.add('drawer--active');
      overlay.classList.add('drawer-overlay--active');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      if (close) close.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('drawer--active');
      overlay.classList.remove('drawer-overlay--active');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      toggle.focus();
    }

    toggle.addEventListener('click', function() {
      if (drawer.classList.contains('drawer--active')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    overlay.addEventListener('click', closeDrawer);
    if (close) close.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && drawer.classList.contains('drawer--active')) {
        closeDrawer();
      }
    });

    if (header) {
      var hasHero = document.querySelector('.hero');
      var mainContent = document.getElementById('main-content');

      if (!hasHero) {
        header.classList.add('header--scrolled');
        if (mainContent) {
          mainContent.style.paddingTop = header.offsetHeight + 'px';
        }
      }

      window.addEventListener('scroll', function() {
        if (window.scrollY > 50 || !hasHero) {
          header.classList.add('header--scrolled');
        } else {
          header.classList.remove('header--scrolled');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[data-social-gallery-section]');

    sections.forEach(function(section) {
      if (section.dataset.socialGalleryReady === 'true') return;
      section.dataset.socialGalleryReady = 'true';

      var track = section.querySelector('[data-social-gallery-track]');
      var prevButton = section.querySelector('[data-social-gallery-prev]');
      var nextButton = section.querySelector('[data-social-gallery-next]');

      if (!track || !prevButton || !nextButton) return;

      function getScrollAmount() {
        var firstItem = track.querySelector('.social-gallery__item');

        if (!firstItem) {
          return Math.max(track.clientWidth * 0.85, 240);
        }

        var computedStyles = window.getComputedStyle(track);
        var gap = parseFloat(computedStyles.columnGap || computedStyles.gap || 0);

        return firstItem.getBoundingClientRect().width + gap;
      }

      function updateControls() {
        var maxScrollLeft = track.scrollWidth - track.clientWidth - 2;
        prevButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maxScrollLeft;
      }

      prevButton.addEventListener('click', function() {
        track.scrollBy({ left: getScrollAmount() * -1, behavior: 'smooth' });
      });

      nextButton.addEventListener('click', function() {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
